import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-719077e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "delete-project-admin-modal__header" }
const _hoisted_2 = { class: "delete-project-admin-modal__username" }
const _hoisted_3 = { class: "delete-project-admin-modal__content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "delete-project-admin-modal__plate-text-row" }, [
  /*#__PURE__*/_createTextVNode("Роль "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Администратора"),
  /*#__PURE__*/_createTextVNode(" проекта будет аннулирована. ")
], -1))
const _hoisted_5 = { class: "delete-project-admin-modal__plate-text-row" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "delete-project-admin-modal__plate-text-row" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "delete-project-admin-modal__radio-list" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "delete-project-admin-modal__radio-hint-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, "доступ во все очереди будет аннулирован"),
  /*#__PURE__*/_createElementVNode("li", null, "будет исключен из всех тикетов как исполнитель / наблюдатель")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "delete-project-admin-modal__description" }, " Выдать/аннулировать участие/права можно в соответствующих подразделах настроек каждой рабочей области/очереди ", -1))

import { computed, PropType, ref } from "vue";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmIconView,
  TirPmModal,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirPmPlate,
  TirPmRadio,
} from "tir-components";
import { NeutralInformation, DimondIcon } from "tir-style-system/icons/solid";
import { AdminModel, SaveAdminsModel, UserModel } from "../../models";
import { AdapterService } from "../../adapter";
import { RouteLocationRaw, useRouter } from "vue-router";
import { CurrentUser } from "tir-pm-user-core";

/**Адаптер */

export default /*#__PURE__*/_defineComponent({
  __name: 'delete-project-admin-modal',
  props: {
  /**Список администраторов */
  admins: {
    type: Array as PropType<Array<AdminModel>>,
    required: true,
  },
  /**ID проекта */
  projectId: {
    type: Number,
    required: true,
  },
},
  emits: ["onSuccessDelete"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const adapter = new AdapterService();
/**Роутер */
const router = useRouter();

// #region defineProps

// #endregion defineProps

// #region defineEmits

// #endregion defineEmits

// #region refs
/**Админ на удаление */
const admin = ref<UserModel>();
/**Загрузка */
const isLoading = ref(false);
/**Сохранить пользователя в команде */
const keepInTeam = ref<"keep" | "no-keep">("keep");
// #endregion refs

// #region computed
const routes = computed<Record<"PerformerTasks" | "ObserverTasks", string> | undefined>(() => {
  if (!admin.value) return;

  const baseRoute: RouteLocationRaw = {
    name: "employee-tasks",
    params: {
      projectId: props.projectId,
      employeeId: admin.value.Id,
    },
  };

  return {
    PerformerTasks: router.resolve({
      ...baseRoute,
      query: {
        role: "performer",
      },
    }).href,
    ObserverTasks: router.resolve({
      ...baseRoute,
      query: {
        role: "observer",
      },
    }).href,
  };
});
// #endregion computed

// #region Функции
/**Открыть модальное окно */
const open = (_admin: UserModel) => {
  admin.value = _admin;
};
/**Закрыть модальное окно */
const close = () => {
  admin.value = undefined;
};
/**Удалить админа */
const deleteAdmin = async () => {
  if (!admin.value) return;

  const admins = props.admins
    .filter((_admin) => _admin.Id !== admin.value.Id)
    .map((admin) => ({
      Id: admin.Id,
      CanCustomizeOrder: admin.CanCustomizeOrder,
    }));
  isLoading.value = true;
  const request = new SaveAdminsModel({
    ProjectId: props.projectId,
    Admins: admins,
    RemoveQueueTasksAccess: keepInTeam.value === "no-keep",
    RemoveTaskObserver: keepInTeam.value === "no-keep",
    RemoveTaskPerformer: keepInTeam.value === "no-keep",
  });
  const resp = await adapter.saveProjectAdmins(request);
  isLoading.value = false;
  
  if (resp.IsSuccess) {
    emit("onSuccessDelete", admin.value.Id);
    TirPmNotificationEventBus.emit(
      "add",
      new TirPmNotificationModel({
        title: "Успешное редактирование",
        type: "success",
        group: "general",
        life: 1000,
        closable: true,
        callbackButton: () => {},
      }),
    );
    close();
  } else {
    TirPmNotificationEventBus.emit(
      "add",
      new TirPmNotificationModel({
        title: resp.ErrorMessage ?? "Произошла ошибка",
        type: "error",
        group: "general",
        life: 5000,
        closable: true,
        callbackButton: () => {},
      }),
    );
  }
};
// #endregion Функции

// #region defineExpose
__expose({
  open,
});
// #endregion defineExpose

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default", { open: open }),
    _createVNode(_unref(TirPmModal), {
      classes: "delete-project-admin-modal",
      "is-with-back": false,
      "is-visible": !!admin.value,
      onClose: close
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(TirPmIconView), {
            "image-load-url": admin.value.Photo,
            "is-rounded": true,
            size: 40,
            "color-code": admin.value.AvatarColor
          }, {
            mainSlot: _withCtx(() => [
              _createTextVNode(_toDisplayString(admin.value.AvatarInitials), 1)
            ]),
            _: 1
          }, 8, ["image-load-url", "color-code"]),
          _createElementVNode("span", _hoisted_2, _toDisplayString(admin.value.Initials), 1)
        ])
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(TirPmPlate), {
            "is-show": true,
            variant: "negative"
          }, {
            leftAddon: _withCtx(() => [
              _createVNode(_unref(NeutralInformation), { class: "delete-project-admin-modal__plate-icon icon-red" })
            ]),
            rightAddon: _withCtx(() => [
              _createVNode(_unref(DimondIcon), { class: "delete-project-admin-modal__plate-second-icon" })
            ]),
            text: _withCtx(() => [
              _hoisted_4,
              _createElementVNode("span", _hoisted_5, [
                _createTextVNode("Является исполнителем в тикетах: "),
                _createElementVNode("a", {
                  href: routes.value.PerformerTasks,
                  target: "_blank"
                }, "список", 8, _hoisted_6)
              ]),
              _createElementVNode("span", _hoisted_7, [
                _createTextVNode("Является наблюдателем в тикетах: "),
                _createElementVNode("a", {
                  href: routes.value.ObserverTasks,
                  target: "_blank"
                }, "список", 8, _hoisted_8)
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_unref(TirPmRadio), {
              name: "delete-project-admin-modal__radio-list",
              value: "keep",
              modelValue: keepInTeam.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keepInTeam).value = $event))
            }, {
              mainSign: _withCtx(() => [
                _createTextVNode(" Оставить в командах всех рабочих областей: ")
              ]),
              hintSign: _withCtx(() => [
                _createTextVNode(" останется доступ во все очереди для просмотра личных тикетов: где является Автором / Исполнителем / Наблюдателем ")
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_unref(TirPmRadio), {
              name: "delete-project-admin-modal__radio-list",
              value: "no-keep",
              modelValue: keepInTeam.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((keepInTeam).value = $event))
            }, {
              mainSign: _withCtx(() => [
                _createTextVNode(" Исключить из команд всех рабочих областей (авторство в тикетах будет сохранено): ")
              ]),
              hintSign: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _hoisted_11
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(TirPmButton), {
          variant: _unref(TirPmButtonVariantEnum).PrimaryState,
          size: _unref(TirPmButtonSizeEnum).Regular,
          "is-loading": isLoading.value,
          onClick: deleteAdmin
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Продолжить ")
          ]),
          _: 1
        }, 8, ["variant", "size", "is-loading"]),
        _createVNode(_unref(TirPmButton), {
          variant: _unref(TirPmButtonVariantEnum).SecondaryState,
          size: _unref(TirPmButtonSizeEnum).Regular,
          onClick: close
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Отмена ")
          ]),
          _: 1
        }, 8, ["variant", "size"])
      ]),
      _: 1
    }, 8, ["is-visible"])
  ], 64))
}
}

})